const TOKEN_KEY = 'murata_token'
const USER_KEY = 'murata_user'
const MENUS_KEY = 'murata_menus'

export function getToken() {
  return localStorage.getItem(TOKEN_KEY)
}

export function setToken(token) {
  localStorage.setItem(TOKEN_KEY, token)
}

export function removeToken() {
  localStorage.removeItem(TOKEN_KEY)
  localStorage.removeItem(USER_KEY)
  localStorage.removeItem(MENUS_KEY)
}

export function getUser() {
  const s = localStorage.getItem(USER_KEY)
  return s ? JSON.parse(s) : null
}

export function setUser(user) {
  localStorage.setItem(USER_KEY, JSON.stringify(user))
}

export function getMenus() {
  const s = localStorage.getItem(MENUS_KEY)
  return s ? JSON.parse(s) : []
}

export function setMenus(menus) {
  localStorage.setItem(MENUS_KEY, JSON.stringify(menus))
}

// 权限缓存（避免每次 hasPermission 都 JSON.parse + 递归）
let _permissionCache = null

/**
 * 重建权限缓存（登录/登出/菜单变更后调用）
 */
export function rebuildPermissionCache() {
  const menus = getMenus()
  const perms = new Set()
  function collect(items) {
    if (!items) return
    for (const item of items) {
      if (item.permission) perms.add(item.permission)
      if (item.children) collect(item.children)
    }
  }
  collect(menus)
  _permissionCache = perms
}

/**
 * 清除权限缓存
 */
export function clearPermissionCache() {
  _permissionCache = null
}

/**
 * 检查当前用户是否拥有指定权限
 * @param {string} perm 权限标识，如 'coc:upload'
 * @returns {boolean}
 */
export function hasPermission(perm) {
  if (!perm) return true
  if (!_permissionCache) rebuildPermissionCache()
  return _permissionCache.has(perm)
}
